import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import RTButton from '../common/RTButton';
import RTSpinner from '../common/RTSpinner';
import { apiGet } from '../../api/apiClient';
import { toastError } from '../common/toast';
import '../common/rtCommon.css';
import './WhatsAppTemplateManagement.css';

const WhatsAppTemplateTags = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const response = await apiGet('/api/whatsapp/message-template-tags');
        const data = response.data || response;
        setTags(Array.isArray(data.tags) ? data.tags : []);
      } catch (err) {
        console.error(err);
        toastError('Failed to load template tags');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="WhatsApp Template Tags"
      mainSection={true}
      actions={
        <RTButton
          variant="secondary"
          onClick={() => navigate('/settings/whatsapp-templates')}
        >
          &#8592; Back to Templates
        </RTButton>
      }
    >
      <div className="wa-tpl-page">
        <p className="wa-tpl-hint">
          These tags are predefined by the system. They cannot be added or
          edited. Each tag maps to a table column used when sending templates to
          active allocations. Use them when creating custom WhatsApp templates.
        </p>

        {loading ? (
          <div className="wa-tpl-spinner">
            <RTSpinner />
          </div>
        ) : (
          <div className="wa-tpl-tags-list">
            {tags.map((tag) => (
              <div key={tag.id} className="wa-tpl-tag-card">
                <div className="wa-tpl-tag-card-title">
                  {tag.display_label}{' '}
                  <span className="wa-tpl-tag-key">{`{{${tag.tag_key}}}`}</span>
                </div>
                <div className="wa-tpl-tag-card-meta">
                  {tag.description || 'No description'}
                  {tag.source_table && tag.source_column ? (
                    <>
                      {' · '}Mapped to{' '}
                      <strong>
                        {tag.source_table}.{tag.source_column}
                      </strong>
                    </>
                  ) : (
                    ' · No column mapping'
                  )}
                  {tag.example_value ? (
                    <>
                      {' · '}Example: <strong>{tag.example_value}</strong>
                    </>
                  ) : null}
                  {!tag.is_active ? ' · Inactive' : null}
                </div>
              </div>
            ))}
            {tags.length === 0 ? (
              <div className="wa-tpl-warning">No tags found.</div>
            ) : null}
          </div>
        )}
      </div>
    </RTPageLayout>
  );
};

export default WhatsAppTemplateTags;
